import React from 'react';
import { Card } from '@sendgrid/ui-components/card';
import PaperAirplane from '../../images/signup-confidence/paper-airplane.svg';
import Styles from './signupConfidenceVariation1.module.scss';

const header = 'Try it out!';
const description = 'Send email for free. Upgrade any time.';

const SignupConfidenceVariation1 = () => (
  <div className={Styles.signupConfidenceVariation1Container}>
    <Card className={Styles.signupConfidenceVariation1Card}>
      <h2>{header}</h2>
      <p>{description}</p>
      <ul>
        <li className="is-size-h3">Automated drip campaigns</li>
        <li className="is-size-h3">Password resets</li>
        <li className="is-size-h3">Newsletters</li>
        <li className="is-size-h3">Receipts</li>
        <li className="is-size-h3">Delivery notifications and updates</li>
        <li className="is-size-h3">Promoted emails</li>
      </ul>
      <img
        className={Styles.signupConfidenceVariation1Img}
        src={PaperAirplane}
        alt="Paper Airplane"
      />
    </Card>
  </div>
);

export default SignupConfidenceVariation1;
